import React from 'react'
import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap'

import './styles/style.css'

// leon global css
import '../../../assets/css/Global/style.css'

const Search = (props) => {
  return (
    <div className={`${props.width && props.width}`}>
      <div className='leon '>
        <Input
          style={{ padding: '18px' }}
          className='form-control-sm col10 lg-col9 md-col10 sm-col7 minWFull searchbar'
          type='search'
          placeholder={props.placeholder ? props.placeholder : ''}
          value={props.value}
          onChange={props.onChange}
          onKeyDown={props.handleKeyDown}
          onInput={(e) => {
            if (e.target.value === '' && props.onXClick) {
              props.onXClick()
            }
          }}
        />
        <InputGroupAddon
          className='col2 lg-col3 md-col2 sm-col3 wFull'
          addonType='append'
          onClick={props.onClick}
        >
          <InputGroupText className='search-btn bg-info wFull flex justifyCenter itemsCenter cursorPointer'>
            <i className='fas fa-search text-white' />
          </InputGroupText>
        </InputGroupAddon>
      </div>
    </div>
  )
}

export default Search
